import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { buttonVariants } from "~/components/ui/button";
import { useNewVersionOnCrash } from "~/components/layout/system-banners";
import { useT } from "~/lib/i18n";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
  notFoundComponent: NotFound,
  errorComponent: Crash,
});

function Root() {
  return (
    <>
      <Outlet />
      <Toaster
        position="top-center"
        toastOptions={{
          className: "!rounded-[10px] !border-line !bg-surface !text-fg !shadow-pop !font-sans",
        }}
      />
    </>
  );
}

function FullPageMessage({ title, body }: { title: string; body: string }) {
  const t = useT();
  return (
    <div className="grid min-h-dvh place-items-center px-6">
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-medium">{title}</h1>
        <p className="mt-2 text-fg-2">{body}</p>
        <Link to="/" className={buttonVariants({ variant: "secondary", className: "mt-6" })}>
          {t("errors.pages.home")}
        </Link>
      </div>
    </div>
  );
}

function NotFound() {
  const t = useT();
  return <FullPageMessage title={t("errors.pages.notFoundTitle")} body={t("errors.pages.notFoundBody")} />;
}

function Crash() {
  const t = useT();
  useNewVersionOnCrash();
  return <FullPageMessage title={t("errors.pages.crashTitle")} body={t("errors.pages.crashBody")} />;
}
